import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, utils} from '@api'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {useTldrawApp} from '@modules/whiteboard'
import {StoresInstance} from '@stores'
import * as css from './SelectedShapesDimensionsToolbar.css'

/// region Store

export class SelectedShapesDimensionsStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }
}

export const SelectedShapesDimensionsStoreContext = React.createContext<SelectedShapesDimensionsStore>(null)
export const useSelectedShapesDimensionsStore = () => React.useContext(SelectedShapesDimensionsStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const SelectedShapesDimensionsToolbar = observer<MyProps>(function SelectedShapesFloatingToolbar({className, ...props}) {
  const tldraw = useTldrawApp(),
    obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new SelectedShapesDimensionsStore(stores, obsProps)),
    {} = store, {selectedBounds} = tldraw

  useEffect(() => store.registerEffects(), [])

  if (!selectedBounds || tldraw.currentTool !== tldraw.tools.tools.select) return null

  const {width, height} = selectedBounds
  return (
    <SelectedShapesDimensionsStoreContext.Provider value={store}>
      <div className={css.root}
           onPointerDown={utils.eatMouseEvent}
           onPointerUp={utils.eatMouseEvent}
      >
        <div className={css.toolbar}>
          <label>{width.toFixed(0).toLocaleString()} x {height.toFixed(0).toLocaleString()}</label>
      </div>
      </div>
    </SelectedShapesDimensionsStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/whiteboard/SelectedShapesDimensionsToolbar.tsx